import { defineComponent as h, inject as B, ref as p, watch as r, computed as s, openBlock as o, createElementBlock as a, normalizeClass as l, createElementVNode as d, createVNode as N, unref as u, createBlock as $, createCommentVNode as c, toDisplayString as f, renderSlot as b, createTextVNode as g } from "vue";
import { getStepStyleClasses as z, getStepIndicatorStyleClasses as A } from "./novoui-vuejs51.js";
import "./novoui-vuejs80.js";
/* empty css               */
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import _ from "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs34.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import { StepperSymbol as E } from "./novoui-vuejs49.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
const I = ["data-testid"], R = {
  key: 0,
  class: "stepper-step-name"
}, T = {
  key: 1,
  class: "stepper-step-description"
}, Ct = /* @__PURE__ */ h({
  __name: "NStep",
  props: {
    complete: { type: Boolean },
    icon: { default: void 0 },
    name: { default: "" },
    description: {},
    active: { type: Boolean },
    index: {}
  },
  emits: ["update:active"],
  setup(v, { emit: S }) {
    const y = S, e = v, t = B(E), n = p(t == null ? void 0 : t.active), k = p(t == null ? void 0 : t.completed);
    r(
      () => t == null ? void 0 : t.active,
      (i, m) => {
        n.value = i;
      }
    ), r(
      () => t == null ? void 0 : t.completed,
      (i, m) => {
        k.value = i;
      }
    );
    const x = s(() => {
      var i;
      return z(n.value === e.index, (i = t == null ? void 0 : t.completed) == null ? void 0 : i.includes(e.index));
    }), C = s(() => A(t == null ? void 0 : t.indicatorType));
    function V(i) {
      if (n.value !== e.index) {
        if (!t)
          return;
        t.updateActiveState(e.index), y("update:active", e.index);
      }
    }
    return (i, m) => (o(), a("li", {
      class: l(["stepper-step", x.value])
    }, [
      d("button", {
        class: "stepper-step-action",
        onClick: V,
        "data-testid": `step_button_${e.index}`
      }, [
        d("span", {
          class: l(["stepper-step-indicator", !e.icon && C.value])
        }, [
          N(u(_), {
            icon: "tick",
            size: 24,
            class: "stepper-step-indicator-complete"
          }),
          e.icon ? (o(), $(u(_), {
            key: 0,
            icon: e.icon,
            size: 16,
            class: "stepper-step-indicator-icon"
          }, null, 8, ["icon"])) : c("", !0)
        ], 2),
        e.name && e.name.trim() ? (o(), a("span", R, f(e.name), 1)) : c("", !0),
        i.$slots.default || e.description ? (o(), a("span", T, [
          b(i.$slots, "default", {}, () => [
            g(f(e.description), 1)
          ])
        ])) : c("", !0)
      ], 8, I)
    ], 2));
  }
});
export {
  Ct as default
};
